<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white p-1"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
      >
        <icon :name="this.module.settings.icon" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        {{ module.title }}
      </h3>
    </div>
    <p class="text-base leading-tight mb-6" v-html="nl2br(module.settings.description)"></p>
    <div v-if="error" class="text-red-dark text-sm">
      <i class="fas fa-exclamation-triangle"></i> {{ error }}
    </div>
    <loader v-else-if="link === null" />
    <div v-else>
      <a
        v-if ="selectedOffice.permissions.includes('access digital hub')"
        :href="link"
        target="_blank"
        class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
        >
      {{ module.settings.cta }}
      </a>
      <button v-else
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
      @click="digitalHubModalOpen = true"
      >
        {{ module.settings.cta }}
      </button>
      <modal v-if="digitalHubModalOpen" @leave="digitalHubModalOpen = false" show-close-btn class="text-center text-sm leading-normal">
      <p>Your access to the Digital Hub is currently blocked. Please contact your Account Manager to resolve this issue</p>
    </modal>
    </div>
  </div>
</template>

<script>
import { nl2br } from '@/helpers'
import { mapState } from 'vuex'
import api from '@/http'
import { debounce } from 'lodash'

export default {
  props: ['module'],

  data () {
    return {
      link: null,
      error: null,
      digitalHubModalOpen: false
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.getLink()
  },
  methods: {
    nl2br,
    getLink: debounce(function () {
      this.link = null
      this.error = null
      api.post('/digital-hub/market-me-now', {
        office_id: this.selectedOffice.id,
        redirect_url: this.module.settings.redirect_url
      }).then((response) => {
        this.link = response.data.link
      }, (error) => {
        this.error = error.response.data.message
      })
    }, 1000)
  },
  watch: {
    selectedOffice: {
      handler () {
        this.getLink()
      },
      deep: true
    }
  }
}
</script>
